import { Component, OnInit, Input } from '@angular/core';
import { ShareDataService} from "@signature-it/ngx-generic/services";
import { SolrTaxonomyService, EntityTreeService } from "@signature-it/ngx-entity/services";

@Component({
  selector: 'app-main-tax-nav',
  templateUrl: './main-tax-nav.component.html',
  styleUrls: ['./main-tax-nav.component.scss'],
    standalone: false
})
export class MainTaxNavComponent implements OnInit {
    tree = {
        nodes: []
    }
    firstLevelInfo = null;
    triggerExpanded;
    @Input() entityTypeVar: string;
    @Input() displayMode: string = 'navbar';

    constructor(public shareSvc: ShareDataService, private entityTreeService: EntityTreeService) { }

    ngOnInit(): void {
        this.entityTreeService.getTaxonomyMenu(this.entityTypeVar).subscribe(
            res => {
                this.tree.nodes = res;
            },
            error => {

            }
        );
    }

    showContent(treeLevel1){
        if(this.triggerExpanded == treeLevel1.id && this.firstLevelInfo){
            this.firstLevelInfo = null;
        } else {
            this.firstLevelInfo = treeLevel1;
            this.triggerExpanded = treeLevel1.id;
        }
    }

}
